import axios from "axios";
import { handleAxiosErrors } from "../utils";

const BASE_URL = "https://api-adresse.data.gouv.fr";
const GET_GEOCODE_VOIE = "/search";

export const getGeoCodageVoie = (adresse, postCode) =>
  axios
    .get(GET_GEOCODE_VOIE, {
      params: {
        q: adresse,
        postcode: postCode,
        type: "housenumber",
      },
      baseURL: BASE_URL,
    })
    .then(response => handleAxiosErrors(response))
    .catch(error => Promise.reject(error));
